/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { Alert, AlertProps } from '@mayoral/ui';
import { styled } from '@mui/material';
import { forwardRef } from 'react';

const BannerRoot = styled(Alert, {
  name: 'Banner',
  slot: 'Root',
})<AlertProps>({
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: 0,
  paddingBottom: 0,
});

type BannerProps = AlertProps;

const Banner = forwardRef<HTMLDivElement, BannerProps>((props, ref) => {
  return <BannerRoot ref={ref} {...props} />;
});

export default Banner;
